import { userService } from './api/users';
import { orgService } from './api/organisations';
import { documentService } from './api/documents';
import { categoryService } from './api/categories'; 
import { docusignService } from './api/docusign';
import { adminService } from './api/admin';
import { emailSettingsService } from './api/emailSettings'; 
import { logoService } from './api/logo'; 


const combinedService = {
  ...userService,
  ...orgService,
  ...documentService,
  ...docusignService,
  ...adminService,       
  ...emailSettingsService, 
  ...categoryService,   
  ...logoService, 
};

export const apiService = combinedService;
